export default "__VITE_ASSET__qhz735g5__"